import { Component, OnInit, OnDestroy, HostBinding, AfterViewInit } from '@angular/core';
import { INode } from './INode';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { HelpService } from '../help-service/help.service';
import { ApplicationService } from '../application-service/application.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventService } from "../config-eventlogs/event.service";
import { ConfigSearchService } from '../config-breadcrumb/config-search/config-search.service';

@Component({
    selector: 'wbm-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['../../assets/theme/css/Configuration.css'],
})
export class ConfigurationComponent implements OnInit, OnDestroy, AfterViewInit {
    public rootNode1: INode;
    public width = "";
    private subscriptions: Array<Subscription> = [];
    public showSidebar: boolean = true;
    percentage: any = "";

    @HostBinding() class = 'flex-container-v nowrap flex-item-fluid bfc';

    constructor(
        public _oxeModel: OxeModelService,
        private _helpService: HelpService,
        private _application: ApplicationService,
        private _route: ActivatedRoute,
        private _eventlogService: EventService,
        private _searchService: ConfigSearchService
    ) { }

    public ngOnInit() {
        this.subscriptions.push(this._route.params.subscribe((params: Params) => {
            this._oxeModel.retrieveOxeModel(params['model'])
                .subscribe(this.setupRootObjectNode.bind(this));
        }));
    }

    ngOnDestroy() {
        //release global subscriptions
        this.removeGlobalSubscriptions();
    }

    showVisible() {
        this.showSidebar = !this.showSidebar;
    }

    public ngAfterViewInit() {
        // BUGFIX: https://github.com/angular/angular/issues/6005#issuecomment-165911194
        setTimeout(_ => this.setConfigDetailWidth(undefined));
    }

    public nodeSelected(node: INode) {
        this._oxeModel.retrieveData(node)
            .subscribe(() => {
                this._oxeModel.selectNode(node);
            });
    }

    private setupRootObjectNode(rootObjectNode: INode): void {
        if (rootObjectNode) {
            // We assume that there is only one OXE to manage
            // N.B. it may theoricaly be possible to get several instance of Node class (i.e. several OXE to manage),
            // here we take care about only the first one
            this.rootNode1 = rootObjectNode;
            // create sub classes nodes
            this._oxeModel.retrieveSubNodes(this.rootNode1)
                .subscribe(() => {
                    // display this object
                    this.nodeSelected(this.rootNode1);
                });

            // Retrieve help file : this must be done after oxe model retrieval, because the help is post-processed with oxe-model definitions
            this._oxeModel.retrieveHelp(this._application.getLanguage())
                .subscribe(data => {
                    this._helpService.setHelpData(data);
                });
        }
    }

    private setConfigDetailWidth($event) {
        this._application.configWidthValue = document.querySelector('wbm-config-detail').clientWidth;
        if ($event != undefined) {
            this.width = $event;
        }

    }

    public get helpDisplayed(): boolean {
        return this._helpService.isHelpDisplayed();
    }

    public get eventLogsAvailable(): boolean{
        return this._eventlogService.isEventDisplayed();
}
    private removeGlobalSubscriptions() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().unsubscribe();
        }
    }
}
